import React from 'react';
import { Badge, BadgeText, CardContent, CardDesc, CardTitle, StepCardContainer } from './styles';

interface InstructionsCardProps {
  step: { num: string; title: string; desc: string };
  index: number;
}

const InstructionsCard: React.FC<InstructionsCardProps> = ({ step, index }) => {
  return (
    <StepCardContainer
      key={index}
      initial={{ y: 30, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1 }}
      whileHover={{ y: -5 }}
    >
      <Badge>
        <BadgeText>{step.num}</BadgeText>
      </Badge>

      <CardContent>
        <CardTitle>{step.title}</CardTitle>
        <CardDesc>{step.desc}</CardDesc>
      </CardContent>
    </StepCardContainer>
  );
};

export default InstructionsCard;
